import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-666b0626"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pr-2" }
const _hoisted_2 = { class: "w-[80%] h-[40rem] self-center" }
const _hoisted_3 = { class: "text-v_dark_blue" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 border-[1px] mb-5 w-[62rem]" }, null, -1))
const _hoisted_6 = { class: "ml-5" }
const _hoisted_7 = { class: "relative w-20 h-[2rem] mt-[-0.5rem]" }
const _hoisted_8 = { class: "overflow" }
const _hoisted_9 = { class: "text-v_green" }
const _hoisted_10 = { class: "text-v_green" }
const _hoisted_11 = { class: "text-v_red" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { className: "mt-2 border-[1px] mb-5 opacity-[90%] w-[62rem]" }, null, -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-v_dark_gray mt-4" }
const _hoisted_15 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione um serviço", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "mt-10 flex justify-center items-center space-x-6" }

import { ref, computed, PropType, onMounted } from "vue"
import Dropzone from "./Dropzone.vue"
import {
	ModalContainer,
	H1,
	H2,
	H3,
	SubTableRowsContainer,
	TableColumnsContainer,
	Input,
	ModalCloseButton,
	ModalButton,
	ModalContentContainer,
	Select,
} from "../atoms"
import { useStore } from "@/store"
import { updatePdf } from "@/repositories/sendNote"
import { Commission } from "@/utils/interfaces"
import CompanyModal from "./CompanyModal.vue"
import { revokeCompanySendingPermission } from "@/utils/permissions"
import { services } from "@/utils/servicesCodes"

type ServiceCode = { partNumber: string; taxService: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'NoteSendingModal',
  props: {
	commissions: { type: Array as PropType<Commission[]>, required: true },
	services: { type: Array as PropType<ServiceCode[]>, required: false },
},
  emits: [
	"enableLoading",
	"closeNoteSendingModal",
	"emitError",
	"successSendingNote",
	"showModal",
],
  setup(__props, { emit }) {

const props = __props;

let headers = ref([
	"Comissão",
	"Nota",
	"Cliente",
	"Total",
	"C.Bruto",
	"Ajuste",
	"Desconto",
])

let total = 0
let totalComissions = ref("")
let docNum = ref("")
let docFile = ref<File[]>([])
let showButton = ref(false)
let codRev = ref("")
let codRevSap = ref("")
let provision = ref<number[]>([])
let base = ref("")
let partNumber = ref("")
let taxServiceCode = ref("")
const onRequest = ref(false)



const store = useStore()



const servicesToUse = computed(() => props.services?.length ? props.services : services)

const getFile = (file: File[]) => {
	docFile.value = file

	if (file.length == 0) showButton.value = false
	else if (file.length > 0 && docNum.value != "") showButton.value = true
}

const checkFile = () => {
	docNum.value = docNum.value.replace(/\D/g, "")

	if (docFile.value.length > 0 && docNum.value != "") showButton.value = true
	else showButton.value = false
}

const checkSelect = () => {
	const service = servicesToUse.value.find((s) => s.partNumber === partNumber.value)
	taxServiceCode.value = service?.taxService || ""
	showButton.value = partNumber.value !== ""
}

const SendNote = async () => {
	showButton.value = false

	emit("enableLoading", true)

	if (!onRequest.value) {
		onRequest.value = true

		const res: any = await updatePdf(
			docFile.value,
			docNum.value,
			base.value,
			provision.value,
			codRev.value,
			codRevSap.value,
			partNumber.value,
			taxServiceCode.value
		)

		if (res?.status == 201) {
			emit("successSendingNote")
			revokeCompanySendingPermission(base.value)
		} else if (res?.status == 415) {
			emit(
				"emitError",
				"Formato de arquivo inválido. Apenas arquivos PDF são aceitos."
			)
		} else if (res?.data?.message.toLowerCase().includes("fora do prazo")) {
			emit("emitError", "Nota fora do prazo de envio!")
		} else {
			emit("emitError", 'Erro ao enviar a solicitação, contate o administrador')
		}

		emit("enableLoading", false)
		onRequest.value = false
	}
}

const uncheckCheckbox = () => {
	let checkbox = document.getElementsByTagName("input")
	let td = document.getElementsByTagName("td")

	for (let i = 0; i <= td.length; i++) {
		td[i]?.setAttribute("style", "background: #fff")
		if (checkbox[i]?.checked == true) {
			checkbox[i].checked = false
		}
	}

	emit("closeNoteSendingModal")
}

const showModal = () => {
	emit("showModal", true)
}

onMounted(() => {
	const totalValue = props.commissions.map((e) => {
		const regex = /[^-\d,]/g

		let totalValueInstring = String(e.total).replace(regex, "")
		let totalValueInNumber = parseFloat(totalValueInstring.replace(",", "."))

		return totalValueInNumber
	})

	for (let i = 0; i < totalValue.length; i++) {
		total += totalValue[i]
	}

	totalComissions.value = total.toLocaleString("pt-BR", {
		style: "currency",
		currency: "BRL",
	})

	codRev.value = store.getters.getCodRev
	codRevSap.value = store.getters.getResaleCode

	provision.value = props.commissions.map((c) => c.provision_Id)
	base.value = props.commissions[0].base
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        width: 15,
        h: "45rem"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "px-2 py-2 float-right w-8 active:scale-90",
              onClick: uncheckCheckbox
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(H1), null, {
                default: _withCtx(() => [
                  _createTextVNode("Comissão")
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(H2), { class: "text-black opacity-[50%] text-left" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Faça upload das notas ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  style: {"background":"rgb(0, 238, 140)"},
                  onClick: showModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(H3), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Expandir ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_unref(SubTableRowsContainer), { class: "!h-[13rem]" }, {
              default: _withCtx(() => [
                _createVNode(_unref(TableColumnsContainer), { class: "mt-2" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), (items, index) => {
                      return (_openBlock(), _createElementBlock("h1", {
                        key: index,
                        class: "text-v_dark_gray3"
                      }, _toDisplayString(items), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.commissions, (items, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(_unref(TableColumnsContainer), { class: "text-[0.8rem] text-v_dark_blue font-[700]" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(index + 1), 1),
                        _createElementVNode("p", null, _toDisplayString(items.note), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(items.client), 1)
                        ]),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(items.total), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(items.brute), 1),
                        _createElementVNode("p", null, _toDisplayString(items.adjustment), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(items.discount), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _hoisted_12
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            (['PRIME', 'PRIMESP'].includes(_unref(props).commissions[0].base))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(Dropzone, {
                    onGetFile: getFile,
                    total: _unref(totalComissions)
                  }, null, 8, ["total"]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Número da nota:")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Input), {
                      modelValue: _unref(docNum),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(docNum) ? (docNum).value = $event : docNum = $event)),
                      onKeyup: checkFile
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_unref(H2), { style: {"text-align":"left"} }, {
                    default: _withCtx(() => [
                      _createTextVNode("Selecione o serviço que será utilizado para a emissão da Nota Fiscal:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Select), {
                    modelValue: _unref(partNumber),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(partNumber) ? (partNumber).value = $event : partNumber = $event)),
                    onChange: checkSelect
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesToUse), (s) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: s.partNumber,
                          value: s.partNumber
                        }, _toDisplayString(s.taxService), 9, _hoisted_17))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_unref(ModalCloseButton), {
                onClick: uncheckCheckbox,
                class: "active:scale-90"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }),
              _createVNode(_unref(ModalButton), {
                disabled: !_unref(showButton),
                class: "active:scale-90",
                enableButton: _unref(showButton),
                onClick: SendNote
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Enviar ")
                ]),
                _: 1
              }, 8, ["disabled", "enableButton"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})